// AI: justified because the generated client (`@app/api-client/generated`) is not
// available until `pnpm api:generate` has been run at least once. After the first
// generation, this file MUST be deleted and the generated hooks used instead.

import { apiAxios } from '@app/api-client';
import type {
  MyWorkSiteDto,
  PhaseCatalogResponse,
  SiteProgressDto,
  ToggleTaskInput,
} from '@app/contracts';

export const fetchPhaseCatalog = (): Promise<PhaseCatalogResponse> =>
  apiAxios<PhaseCatalogResponse>({ url: '/api/v1/progression/catalog', method: 'GET' });

export const fetchMySites = (): Promise<MyWorkSiteDto[]> =>
  apiAxios<MyWorkSiteDto[]>({ url: '/api/v1/users/me/sites', method: 'GET' });

export const fetchSiteProgress = (siteId: string): Promise<SiteProgressDto> =>
  apiAxios<SiteProgressDto>({ url: `/api/v1/progression/sites/${siteId}`, method: 'GET' });

export const toggleTask = (
  siteId: string,
  taskCode: string,
  input: ToggleTaskInput,
): Promise<void> =>
  apiAxios<void>({
    url: `/api/v1/progression/sites/${siteId}/tasks/${taskCode}/complete`,
    method: 'POST',
    data: input,
  });

export const advanceUser = (siteId: string): Promise<void> =>
  apiAxios<void>({ url: `/api/v1/progression/me/sites/${siteId}/advance`, method: 'POST' });

export const setPreferredSite = (siteId: string): Promise<{ ok: true }> =>
  apiAxios<{ ok: true }>({
    url: '/api/v1/users/me/preferred-site',
    method: 'PATCH',
    data: { siteId },
  });
